__webpack_require__.p = "https://assets.yanolja.com/platform-site/prod/07679e8864fba9eafd44cd8881d08ad4f23ffaed/_next/";